import en from "../assets/locale/en.json";
import ja from "../assets/locale/ja.json";

const pageLocale = (page) => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  if (urlParams.get("locale") === "ja") {
    return ja[page];
  }
  return en[page];
};

export { pageLocale };
